import styled from 'styled-components';

import { OnboardingPage } from '@/pages/Onboarding/components/Page';

export const RoleplayStyles = styled(OnboardingPage)`
  ion-content {
    --overflow: hidden;

    .onboarding-name-title {
      text-align: center;
    }

    .images-container {
      margin: 16px 0;
      height: 268px;
      width: 100%;
      background-color: transparent;
      position: relative;
    }

    .content {
      margin-top: 200px;
    }

    .input-container {
      max-width: 372px;
      padding: 0 16px;
      width: 100%;
      margin: 16px auto 0;
    }
  }
`;

export const ImageContainerStyles = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

export const ImageStyles = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: blur(8px);
  transform: scale(1.05);
  opacity: 0.2;
`;

export const OverlayStyles = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: fill;
  z-index: 1;
`;
